<template>
    <div class="boxPage">
        <div class="boxList">
            <div class="listTitle">{{ listData.quoteName }}</div>
            <div>{{ listData.couponPlatForm === 90 ? '窝窝投' : listData.couponPlatForm === 100 ? '其他' :
                listData.couponPlatForm ===
                    30 ? '美团' : listData.couponPlatForm === 20 ? '抖音' : listData.couponPlatForm === 10 ? '大众点评' : '' }}
            </div>
            <div class="coupon">
                <!-- 展示优惠券二维码 -->
                <vue-qr v-if="listData.couponPlatForm === 90"
                    :text="`https://apph5web.wowotown.com/writeOff?id=${listData.id}`" :size="200"></vue-qr>
                <span>{{ listData.id }}</span>
            </div>
            <div class="listBox">
                <div class="itemList">
                    <span>使用平台：</span>
                    <span>{{ listData.couponPlatForm ===
                        10 ? '大众点评' : listData.couponPlatForm === 20 ? '抖音' :
                        listData.couponPlatForm ===
                            30 ? '美团' : listData.couponPlatForm === 90 ? '窝窝投' : '' }}</span>
                </div>
                <div class="itemList">
                    <span>有效期：</span>
                    <span v-if="listData.longTermStatus === 10">长期</span>
                    <span v-else>{{ formatDate(listData.startTime) }}-{{
                        formatDate(listData.endTime) }}
                    </span>
                </div>
                <div class="itemList">
                    <span style="width:60px;display: inline-block;">使用说明：</span>
                    <span>{{ listData.instructions }}</span>
                </div>
            </div>
            <div class="buts">
                <van-button class="configButs" @click="submit">确认核销</van-button>
                <van-button class="configButs" @click="gotoRecord">核销记录</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import vueQr from "vue-qr";
import { getCouponByRecordDetail, fetchUseProduct } from '@/services/task'
import { Notify, Toast } from 'vant';
import Cookies from "js-cookie";
export default {
    components: {
        vueQr,
    },
    data() {
        return {
            id: '',
            listData: {}
        };
    },
    mounted() {
        this.id = this.$route.query.id;
        this.list();
    },
    methods: {
        gotoRecord() {
            this.$router.push({
                path: '/VerificationRecord'
            })
        },
        submit() {
            fetchUseProduct({ activitySendId: this.id }).then((res) => {
                if (res.code === 0) {
                    Toast({
                        message: '核销成功',
                        position: "center",
                    });
                    localStorage.setItem('writeOffData', JSON.stringify({
                        quoteName: this.listData.quoteName,
                        startTime: this.listData.startTime,
                        endTime: this.listData.endTime,
                        longTermStatus: this.listData.longTermStatus
                    }));
                    this.$router.push({
                        path: '/WriteOffSuccess',
                        // query: {
                        //     quoteName: this.listData.quoteName,
                        //     startTime: this.listData.startTime,
                        //     endTime: this.listData.endTime,
                        //     longTermStatus: this.listData.longTermStatus
                        // }

                    })
                } else if (res.code === 10004) {
                    Toast({
                        message: res.msg,
                        position: "center",
                    });

                } else {
                    Toast({
                        message: '核销失败',
                        position: "center",
                    });
                }
            })
        },
        list() {
            getCouponByRecordDetail(this.id).then((res) => {
                if (res.code === 1001) {
                    Notify({
                        message: res.msg,
                        position: "center",
                    })
                    Cookies.remove('token');
                    Cookies.remove('secretKey');
                    this.$router.replace("/WriteOfferror");
                } else {
                    res.data.startTime = res.data.startTime.split(' ')[0];
                    res.data.endTime = res.data.endTime.split(' ')[0];
                    this.listData = res.data;
                }
            })
        },
        formatDate(dateStr) {
            const parts = dateStr.split('-');
            if (parts.length === 3) {
                return `${parts[0]}年${parts[1]}月${parts[2]}日`;
            }
            return dateStr;
        }
    }
}
</script>

<style lang="less" scoped>
.boxPage {
    height: 100vh;
    background-color: #F7F8FC;
    padding: 20px;
}

.boxList {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    // width: 80%;
    background-color: #ffffff;
    margin-top: 20px;
    padding: 20px;
    border-radius: 10px;
}

.configButs {
    width: 45%;
    background: #17c1ce;
    color: #ffffff;
    height: 40px;
    border-radius: 5px;
}

.coupon {
    text-align: center;
}

.buts {
    display: flex;
    justify-content: space-around;
    width: 100%;
    position: absolute;
    bottom: 40px;
}

.listTitle {
    font-weight: bold;
    font-size: 18px;
}

.listDate {
    font-size: 16px;
}

.listBox {
    background-color: #F7F8FC;
    padding: 15px;
    margin-top: 15px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.itemList {
    display: flex;
    font-size: 14px;
    margin-bottom: 12px;
    line-height: 1.5;

    &:last-child {
        margin-bottom: 0;
    }

    span:first-child {
        min-width: 70px;
        color: #666;
        flex-shrink: 0;
    }

    span:last-child {
        color: #333;
        flex: 1;
        word-break: break-all;
    }
}
</style>
